import { gql } from '@apollo/client';

export const GET_SHORTCUTS = gql`
  query shortcuts {
    shortcuts {
      id
      type
      title
      main_picture
      group_id
      only_for_registered
      age_rating
      free_run
      sort
      group {
        id
        sort
        title
        groupType
      }
    }
  }
`;

export const UPDATE_ALL_SHORTCUTS = gql`
  mutation updateAllShortcut(
    $updateShortcutId: Int!
    $updateShortcutInput: ShortcutInput!
    $updateShortcutSortInput: [UpdateShortcutSortInput!]!
  ) {
    updateShortcut(id: $updateShortcutId, input: $updateShortcutInput) {
      id
      type
    }

    updateShortcutSort(input: $updateShortcutSortInput)
  }
`;

export const DELETE_BILLING_SHORTCUT = gql`
  mutation deleteShortcut($id: Int!, $sync: SyncScope) {
    deleteShortcut(id: $id, sync: $sync) {
      type
    }
  }
`;

export const UPDATE_SORT = gql`
  mutation updateShortcutSort($input: [UpdateShortcutSortInput!]!) {
    updateShortcutSort(input: $input)
  }
`;

export const UPDATE_SHORTCUT = gql`
  mutation updateShortcut($id: Int!, $input: ShortcutInput!) {
    updateShortcut(id: $id, input: $input) {
      id
      type
    }
  }
`;

export const SHORTCUT_GROUPS = gql`
  query ShortcutGroups {
    shortcutGroups {
      id
      sort
      title
      groupType
    }
  }
`;

export const CREATE_SHORTCUT_GROUPS = gql`
  mutation createShortcutGroup($input: ShortcutGroupInput!, $sync: SyncScope) {
    createShortcutGroup(input: $input, sync: $sync) {
      id
      groupType
      sort
      title
    }
  }
`;

export const UPDATE_SHORTCUT_GROUPS = gql`
  mutation UpdateShortcutGroup(
    $updateShortcutGroupId: Int!
    $sync: SyncScope
    $input: ShortcutGroupInput!
  ) {
    updateShortcutGroup(
      id: $updateShortcutGroupId
      sync: $sync
      input: $input
    ) {
      groupType
      id
      sort
      title
    }
  }
`;

export const DELETE_SHORTCUT_GROUPS = gql`
  mutation deleteShortcutGroup($id: Int!, $sync: SyncScope) {
    deleteShortcutGroup(id: $id, sync: $sync) {
      groupType
      id
      sort
      title
    }
  }
`;

export const UPDATE_SHORTCUT_GROUPS_SORT = gql`
  mutation updateShortcutGroupSort($input: [UpdateShortcutGroupSortInput!]!) {
    updateShortcutGroupSort(input: $input)
  }
`;
